import React, { useState, useEffect, useRef } from 'react';
import moment from 'moment';
import { getMaxDays } from '../ReactGlobals.js';

export const RDatePicker = props => {
    var today = moment(); //props.defaultValue ? moment(props.defaultValue) :
    const [selectedDate, setSelectedDate] = useState(props.defaultValue ? props.defaultValue : ""); //today.format("MMMM DD, YYYY")
    const [month, setMonth] = useState(today.format("MM"));
    const [year, setYear] = useState(props.limitYear ?
        moment("1/1/" + props.limitYear).format("YYYY") : today.format("YYYY"));
    const mainDiv = useRef(null); 
    const windowRef = useRef(null);

    const [calendarDates, setCalendarDates] = useState([]);
    const [yearOptions, setYearOptions] = useState([]);

    const [heightFlag, setHeightFlag] = useState('');

    const cycleMonths = (m, isPrev = true) => {
        if (isPrev) {
            if (m == 1) {
                setMonth("12");
                setYear(_year => parseInt(_year) - 1);
            } else {
                setMonth(_month => moment((parseInt(_month) - 1) + "/22/2222").format("MM"));
            }
        } else {
            if (m == 12) {
                setMonth(1);
                setYear(_year => parseInt(_year) + 1);
            } else {
                setMonth(_month => moment((parseInt(_month) + 1) + "/22/2222").format("MM"));
            }
        }
    }

    useEffect(_ => {
        if (props.selectedDate == "") setSelectedDate("");
    }, [props.selectedDate]);

    useEffect(_ => {
        props.onChange ? props.onChange(selectedDate) : console.log("[RDatePicker] No onChange function");
    }, [selectedDate])

    useEffect(_ => {
        if(props.defaultValue){
            var d = moment(props.defaultValue);
            setMonth(d.format("MM"));
            setYear(d.format("Y"));
            setSelectedDate(d.format("MMMM DD, YYYY"));
        } //(( + ) - 0) + `(${window.innerHeight})` + " <= 0"
    },[])

    useEffect(_ => {
        var yearRange = props.yearRange ? props.yearRange : 10;
        var _yearOptions = [];
        //var currentYear = moment().format("YYYY");
        var yearToAdd = parseInt(year) + (yearRange / 2) - 1;

        if (props.limitYear && (props.absolute || yearToAdd > props.limitYear)) yearToAdd = props.limitYear;

        while (_yearOptions.length < yearRange) {
            _yearOptions.push(yearToAdd);
            yearToAdd = yearToAdd - 1;
        }
        setYearOptions(_yearOptions);
    }, [year]);

    useEffect(_ => {
        var _calendarDates = [];
        var _day = 1;
        var _maxDays = getMaxDays(month, moment(year+"/12/31").isLeapYear());
        var _weekday = moment(month + "/1/" + year).format("d");

        while (_day <= _maxDays) {
            var _week = [];
            for (let i = 0; i < 7; i++) {
                if (_calendarDates.length == 0) {
                    if (i < _weekday) {
                        _week.push("");
                        continue;
                    }
                }
                if (_day <= _maxDays) {
                    _week.push(month + "/" + _day + "/" + year);
                    _day += 1;
                } else {
                    _week.push("");
                }
            }
            _calendarDates.push(_week);
        }
        setCalendarDates(_calendarDates);
    }, [month, year]);
    const [divHeight, setDivHeight] = useState(0);
    useEffect(_ => {
        var cHeight = windowRef.current.clientHeight;
        if (cHeight > divHeight) {
            //alert(cHeight);
            setDivHeight(cHeight);
        } else {
            //alert(`${divHeight} + ${windowRef.current.offsetTop} (offset) + ${mainDiv.current.offsetTop}`)
            if ((heightFlag == 'top') || divHeight + windowRef.current.offsetTop + mainDiv.current.offsetTop > window.innerHeight - 30) setHeightFlag('top');
            else setHeightFlag('');
        }
    }, [calendarDates, divHeight]);


    return <div className="rdatepicker" tabIndex="0" ref={mainDiv}>
        <div className="dpicker-input">
            <div className="input-group">
                <div className="input-group-prepend">
                    <div className="input-group-text" style={{ padding: "0px 10px", height: "100%" }}><i className="fa fa-calendar-days"></i></div>
                </div>
                <input name={props.name} ref={props.reffy} type="text" className="form-control" value={selectedDate} placeholder={props.placeholder ? props.placeholder : ""} onChange={e => {
                    if (e.target.value == "") {
                        setSelectedDate("");
                    }
                    else {
                        var input_date = moment(e.target.value);
                        if (input_date.isValid()) {
                            setMonth(input_date.format("MM"));
                            setYear(input_date.format("YYYY"));
                            setSelectedDate(input_date.format("MMMM DD, YYYY"));
                        }
                    }
                }} />
            </div>
            {/* <input value={selectedDate} placeholder={props.placeholder?props.placeholder:""} /> */}
        </div>
        <div ref={windowRef} className={
            `dpicker-main ${heightFlag} ${props.limitDateBefore ? "starting-range" : (props.limitDateAfter ? "ending-range" : "")}`}>
            <div className="dpicker-datenav">
                <button type="button" className="ro-button mr-3 px-2" onClick={_ => cycleMonths(month)}>
                    <i className="fa fa-arrow-left"></i>
                </button>
                <select onChange={e => setMonth(e.target.value)} value={month}>
                    <option name="January" value="01">January</option>
                    <option name="February" value="02">February</option>
                    <option name="March" value="03">March</option>
                    <option name="April" value="04">April</option>
                    <option name="May" value="05">May</option>
                    <option name="June" value="06">June</option>
                    <option name="July" value="07">July</option>
                    <option name="August" value="08">August</option>
                    <option name="September" value="09">September</option>
                    <option name="October" value="10">October</option>
                    <option name="November" value="11">November</option>
                    <option name="December" value="12">December</option>
                </select>
                <select className="ml-2" value={year} onChange={e => setYear(e.target.value)}>
                    {
                        yearOptions.map(y => <option key={y}>{y}</option>)
                    }
                </select>
                <button type="button" style={props.limitYear && month == '12' && year + 1 > props.limitYear ? {pointerEvents:"none"} : {}}
                    disabled={props.limitYear && month == '12' && year + 1 > props.limitYear}
                    className="ro-button ml-3 px-2" onClick={_ => cycleMonths(month, false)}>
                    <i className="fa fa-arrow-right"></i>
                </button>
            </div>
            <hr className="mb-1 mt-2" />
            <div className="dpicker-weeks">
                <span>Su</span>
                <span>Mo</span>
                <span>Tu</span>
                <span>We</span>
                <span>Th</span>
                <span>Fr</span>
                <span>Sa</span>
            </div>
            <hr className="my-1" />
            <div className="dpicker-days">
                {
                    calendarDates.map((w,w_index) => <div key={w}>
                        {
                            w.map((d,d_index) => {
                                if (d == "") return <div key={w_index+":"+d_index} className="no-date"></div>;

                                var _date = moment(d);

                                return <div onClick={_ => {
                                        setSelectedDate(_date.format("MMMM DD, YYYY"));
                                        if(!props.noSelectClose) mainDiv.current.blur();
                                    }
                                } key={w_index + ":" + d_index} 
                                className={`no_selection ${
                                        _date.format("MMMM DD, YYYY") == selectedDate ? 
                                        "selected" : ""
                                    }${
                                        props.limitDateBefore && props.limitDateBefore != "" ?
                                        (
                                            moment(_date.format("YYYY-MM-DD")).isBefore(moment(props.limitDateBefore).format("YYYY-MM-DD")) ?
                                            " disabled" : ""
                                        ):""
                                    }${
                                        props.limitDateAfter && props.limitDateAfter != "" ?
                                        (
                                            moment(_date.format("MMMM DD, YYYY")).isAfter(moment(props.limitDateAfter).format("MMMM DD, YYYY")) ?
                                            " disabled" : ""
                                        ):""
                                    }${
                                        props.rangeMode && (
                                            (props.limitDateBefore && props.limitDateBefore != "") || 
                                            (props.limitDateAfter && props.limitDateAfter != "")
                                        ) ?
                                        (
                                            moment(_date.format("MMMM DD, YYYY")).isSame(
                                                props.limitDateBefore && props.limitDateBefore != "" ?
                                                (
                                                    moment(props.limitDateBefore).format("MMMM DD, YYYY")
                                                )
                                                :(
                                                    moment(props.limitDateAfter).format("MMMM DD, YYYY")
                                                )
                                            ) ? (
                                                !moment(
                                                    moment(props.limitDateAfter ?
                                                        props.limitDateAfter:props.limitDateBefore).format("MMMM DD, YYYY")
                                                        ).isSame(moment(selectedDate).format("MMMM DD, YYYY"))  ? " range-end" : ""
                                            ) : ""
                                        ):""
                                    }${
                                        props.rangeMode && (
                                            (props.limitDateBefore && props.limitDateBefore != "") || 
                                            (props.limitDateAfter && props.limitDateAfter != "")
                                        ) ?
                                        (
                                            moment(_date.format("MMMM DD, YYYY")).isBefore(
                                                props.limitDateBefore && props.limitDateBefore != "" ?
                                                (
                                                    moment(selectedDate).format("MMMM DD, YYYY")
                                                )
                                                :(
                                                    moment(props.limitDateAfter).format("MMMM DD, YYYY")
                                                )
                                            ) &&
                                            moment(_date.format("MMMM DD, YYYY")).isAfter(
                                                props.limitDateAfter && props.limitDateAfter != "" ?
                                                (
                                                    moment(selectedDate).format("MMMM DD, YYYY")
                                                )
                                                :(
                                                    moment(props.limitDateBefore).format("MMMM DD, YYYY")
                                                )
                                            ) ? " range-between" : ""
                                        ):""
                                    }`
                                    }>
                                    {_date.format("D")}
                                </div>
                            })
                        }
                    </div>)
                }
            </div>
        </div>
    </div>
}